module.exports = __webpack_public_path__ + "img/down.7acacea7.gif";